import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { Outlet } from 'react-router-dom';
import { NOT_FOUND } from '../constants/errors';
import { FarmActionsQuery } from '../queries';

const FarmAuthorizationLayout = ({ action = 'canAccess' }) => {
  const { farmId } = useParams();
  const { loading, error, data } = useQuery(FarmActionsQuery, {
    context: { priorityOp: true },
    variables: { farmId },
  });

  if (loading) return null;
  if (error || !data.farm?.allowedActions?.[action]) throw new Error(NOT_FOUND);

  return <Outlet />;
};

export default FarmAuthorizationLayout;
